import React, { Component, Fragment } from 'react';
import { createPortal } from 'react-dom';
import Panel from '../../../components/Panel';
import { IMPEDANCE_PACKAGE, IMPEDANCE_PCB } from '../../../services/Cascade/constants';
import EditableTable from '../../../components/EditableTable';
import { getAllCascadeNets } from '../../../services/Cascade/helper/setupData';
import designConstructor from '../../../services/helper/designConstructor';
import auroraDBJson from '../../../services/Designs/auroraDbData';
import componentSetting from '../../../services/Cascade/helper/compSettingHelper';
import _ from 'lodash';
import preLayoutData from '../../../services/Cascade/prelayout/preLayoutData';

const columns = [
  {
    title: 'Package',
    dataIndex: IMPEDANCE_PACKAGE,
    width: '50%'
  }, {
    title: 'PCB',
    dataIndex: IMPEDANCE_PCB,
    width: '50%',
  }
]

class PackageRelationship extends Component {
  constructor(props) {
    super(props);
    this.state = {
      table: props.packageRelationship || [],
      options: [],
      save: false
    }
    this.dialogRoot = document.getElementById('root')
  }

  componentDidMount = async () => {
    this.getOptions();
    this.initColumns();
  }

  getOptions = async () => {
    const { packageDesignId } = this.props;
    const isPrelayout = designConstructor.isPreLayout(packageDesignId);
    if (!isPrelayout) {
      const exsit = auroraDBJson.checkAuroraJson(packageDesignId);
      if (!exsit) {
        const setting = await componentSetting.getSetting({ designId: packageDesignId })
        await auroraDBJson.getAuroraJson(packageDesignId, setting)
      }
    } else {
      await preLayoutData.getPreLayout(packageDesignId)
    }
    const nets = getAllCascadeNets({ pcbId: packageDesignId })
    this.setState({
      options: nets.sort()
    })
  }

  initColumns = () => {
    columns[0].render = (text = []) => {
      return <div>{text.join(', ')}</div>
    }

    columns[1].render = (text = []) => {
      return <div>{text.join(', ')}</div>
    }

    columns[0].onCell = (record) => {
      const text = (record[IMPEDANCE_PACKAGE] || []).join(', ')
      const { options } = this.state;
      return {
        edit: 'select',
        options: options,
        record,
        text: text,
        dataIndex: IMPEDANCE_PACKAGE,
        selectMode: 'multiple',
        handleSave: (record) => this.savePartNumber(record),
        getPopupContainer: document.getElementById('root'),
      }
    }
  }

  savePartNumber = (record) => {
    const { index } = record;
    const { table, save } = this.state;
    const _table = [...table];
    const prevNets = JSON.parse(JSON.stringify(_table[index][IMPEDANCE_PACKAGE]))
    _table[index][IMPEDANCE_PACKAGE] = record[IMPEDANCE_PACKAGE];
    this.setState({
      table: _table,
      save: !_.isEqual(prevNets, record[IMPEDANCE_PACKAGE]) ? true : save
    })
  }

  closeModal = () => {
    const { table, save } = this.state;
    save && this.props.updatePackageRelationship(table)
    this.props.onCancel()
  }

  render() {
    const { table } = this.state;
    const dataSources = table.map((t, index) => ({ ...t, index }))
    const content = (
      <Fragment>
        <Panel
          className='cascade-power-select-panel'
          title={<div className='cascade-power-select-title'>{`Nets relationship between PCB and Package`}</div>}
          onCancel={this.closeModal}
          zIndex={2000}
          width={600}
          maxHeight={1000}
          position='panel-center'
          draggable
          minHeight={500}
          minWidth={600}
          defaultTop={200}
        >
          <div className='cascade-package-relationship-content'>
            <EditableTable
              rowKey="index"
              columns={columns}
              size="small"
              dataSource={dataSources}
            />
          </div>
        </Panel>
      </Fragment>
    )
    return createPortal(content, this.dialogRoot)
  }
}

export default PackageRelationship;